import { DateTime } from 'luxon';

import { getEndOf } from 'removePartialIntervals';

const build2DDateComparisonRowData = ({
  chartDef,
  usedMetrics,
  current,
  rangeBuckets,
  currentDateScope,
  unitsLocale,
}: {
  chartDef: V5ChartDefinition;
  usedMetrics: Metrics.Metric[];
  current: MatrixRowData[];
  rangeBuckets: string[];
  currentDateScope: DateRangeInput;
  unitsLocale: string;
}): MatrixComparisonRowData[] => {
  const comparisonData = [] as MatrixComparisonRowData[];
  if (chartDef.series.length !== 1) {
    return comparisonData;
  }
  const s = chartDef.series[0];
  const metric = usedMetrics.find((m) => m.id === s.metricId);
  if (!metric) {
    return comparisonData;
  }

  current.forEach((currentRow) => {
    const row = {} as MatrixComparisonRowData;
    if (chartDef.dimensionA && chartDef.dimensionB) {
      const dimensionA = chartDef.dimensionA.field;
      // @ts-ignore
      row[dimensionA] = currentRow[dimensionA];
      if (chartDef.secondaryDimensionA) {
        const secondaryField = chartDef.secondaryDimensionA.field;
        // @ts-ignore
        row[secondaryField] = currentRow[secondaryField];
      }
      rangeBuckets.forEach((isoDate, index) => {
        if (index === 0) {
          // @ts-ignore
          row[isoDate] = currentRow[isoDate];
          // @ts-ignore
          row[`${isoDate}-raw`] = currentRow[`${isoDate}-raw`];
        } else {
          if (s.matrixCellType) {
            // @ts-ignore
            const currentVal = currentRow[`${isoDate}-raw`];
            const previousIsoDate = rangeBuckets[index - 1];
            // @ts-ignore
            const previous = currentRow[`${previousIsoDate}-raw`];

            const currentDateRange = (() => {
              const endDate = (() => {
                const isLastDate = index === rangeBuckets.length - 1;
                if (!isLastDate) {
                  return DateTime.fromMillis(
                    getEndOf(
                      DateTime.fromISO(isoDate).toMillis(),
                      chartDef.trendByCalendarInterval,
                    ),
                  )
                    .minus({ day: 1 })
                    .toISODate();
                }

                return currentDateScope.endDate;
              })();

              return {
                startDate: isoDate,
                endDate,
              } as DateRangeInput;
            })();
            const previousDateRange = (() => {
              const endDate = DateTime.fromMillis(
                getEndOf(
                  DateTime.fromISO(previousIsoDate).toMillis(),
                  chartDef.trendByCalendarInterval,
                ),
              )
                .minus({ day: 1 })
                .toISODate();
              return {
                startDate: previousIsoDate,
                endDate,
              } as DateRangeInput;
            })();
            const deltaCol = {
              value: currentVal,
              previous,
              formatting: metric.formatting,
              unitsLocale,
              type: 'delta' as MatrixCellType,
              currentDateRange,
              previousDateRange,
              metric,
            };
            const percentDeltaCol = {
              value: currentVal,
              previous,
              formatting: metric.formatting,
              unitsLocale,
              type: 'percentDelta' as MatrixCellType,
              currentDateRange,
              previousDateRange,
              metric,
            };

            if (s.matrixCellType === 'both') {
              // @ts-ignore
              row[`${isoDate}-delta`] = deltaCol;
              // @ts-ignore
              row[`${isoDate}-percentDelta`] = percentDeltaCol;
            } else if (s.matrixCellType === 'delta') {
              // @ts-ignore
              row[`${isoDate}-delta`] = deltaCol;
            } else {
              // @ts-ignore
              row[`${isoDate}-percentDelta`] = percentDeltaCol;
            }
            // @ts-ignore
            row[isoDate] = currentRow[isoDate];
          } else {
            // @ts-ignore
            row[isoDate] = currentRow[isoDate];
          }
          // Threshold colours read the unformatted value
          if (s.cellColourConfig) {
            // @ts-ignore
            row[`${isoDate}-raw`] = currentRow[`${isoDate}-raw`];
          }
        }
      });
      comparisonData.push(row);
    }
  });
  return comparisonData;
};

export default build2DDateComparisonRowData;
